// extracted by mini-css-extract-plugin
export default {"uploaded-document":"TextInput_uploaded-document__FDdJe","claims-email-summary":"TextInput_claims-email-summary__N-ZzP"};